<template>
  <div class="sign-in page">
    <template v-if="showComponent === null">
      <br /><br />
      <div class="columns is-centered">
        <div class="column is-half is-narrow">
          <div class="box">
            <h1 class="title is-5 has-text-dark">Sign In</h1>
            <form @submit.prevent="signIn">
              <b-field label="Username">
                  <b-input placeholder="usename" v-model="username"></b-input>
                </b-field>

                <b-field label="Password">
                  <b-input type="password" placeholder="pasword" v-model="password"></b-input>
                </b-field>

                <div v-if="errMsg.length" class="notification is-danger">
                  {{ errMsg }}
                </div>
                <button tyoe="submit" class="button" :class="{'is-loading': isSigningIn}">
                  Sign In
                </button>
              </form>

          </div>
        </div>
      </div>
    </template>

    <template v-else-if="showComponent === 'machine-alerts'">
      <machine-alerts />
    </template>

  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'

import MachineAlerts from '@/components/MachineAlerts'

export default {
  components: { MachineAlerts },
  name: 'SignIn',
  data () {
    return {
      errMsg: '',
      username: '',
      password: '',
      isSigningIn: false,
      showComponent: null
    }
  },
  created () {
    if (navigator.userAgent === 'machine-alerts') {
      this.showComponent = navigator.userAgent
      setInterval(() => location.reload(), 1000 * 60 * 60)
    }
  },
  methods: {
    signIn () {
      this.errMsg = ''
      this.isSigningIn = true
      let email = `${this.username}@sdfdev.com`
      firebase.auth().signInWithEmailAndPassword(email, this.password)
        .then(user => {
          this.isSigningIn = false
          this.$router.replace('home')
        })
        .catch(error => {
          this.isSigningIn = false
          this.errMsg = error.message
        })
    }
  }
}
</script>

<style>
.sign-in {
  height: 100%;
}

.sign-in .row {
  height: 70%;
}

</style>
